import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ViewChild,
  inject,
} from '@angular/core';
import { LanguageStore } from 'src/core/stores';
import { DropdownComponent } from '../elements/dropdown/dropdown.component';

@Component({
  selector: 'core-language-select',
  templateUrl: './language-select.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, DropdownComponent],
})
export class LanguageSelectComponent {
  languageStore = inject(LanguageStore);

  @ViewChild(DropdownComponent) dropdownComponent!: DropdownComponent;

  changeLanguage(language: string) {
    this.languageStore.setLanguage(language);
    this.dropdownComponent.closeDropdown();
  }
}
